const d3 = require('d3')

const apiClient = require('../graphql/apiClient')

const { gql } = require('graphql-tag')

const _ = {
  each: require('lodash/each'),
}

const FILTER_LABELS_QUERY = gql`
  query filterLabels {
    labels
  }
`

const URL_PARAM = 'label'

function filterLabels() {
  return apiClient(FILTER_LABELS_QUERY, {})
    .then((res) => res.json())
    .then((result) => {
      return result.data.labels.sort()
    })
}

function shouldBlipBeDrawn(blip) {
  const labelFilter = new URL(document.location).searchParams.get(URL_PARAM)
  return !labelFilter || blip.labels().split(',').includes(labelFilter)
}

function filterByDropdownLabel() {
  const dropdown = document.getElementById('wkc-filter-dropdown')
  const selectedOption = dropdown.options[dropdown.selectedIndex]
  if (selectedOption) {
    const urlParams = new URLSearchParams(window.location.search)
    urlParams.set(URL_PARAM, selectedOption.value)
    window.location.search = urlParams
  }
}

function setSelectedOptionInFilterDropdown() {
  const dropdown = document.getElementById('wkc-filter-dropdown')
  const urlParams = new URLSearchParams(window.location.search)
  const selectedLabel = urlParams.get(URL_PARAM)
  if (selectedLabel) {
    dropdown.value = selectedLabel
    d3.select('#wkc-filter-clear-button').style('visibility', 'visible')
  }
}

function createBlipCategoryFilter(searchContainer) {
  // World Kinect (WK) - Filter by Labels
  var clearLabelParams = new URLSearchParams(window.location.search)
  clearLabelParams.delete(URL_PARAM)

  var labelDropdownOptions = '<option value="" selected disabled>Filter</option>'

  filterLabels().then((labels) => {
    _.each(labels, function (label) {
      labelDropdownOptions += `<option value="${label}"> ${label} </option>`
    })

    searchContainer
      .append('select')
      .attr('id', 'wkc-filter-dropdown')
      .on('change', filterByDropdownLabel.bind())
      .classed('wkc-filter-dropdown', true)
      .html(labelDropdownOptions)

    searchContainer
      .append('a')
      .attr('id', 'wkc-filter-clear-button')
      .attr('href', '?' + clearLabelParams)
      .attr('title', 'Reset Filter')
      .classed('wkc-filter-clear-button', true)
      .style('visibility', 'hidden')
      .text('❌')

    setSelectedOptionInFilterDropdown()
  })
}

module.exports = {
  shouldBlipBeDrawn,
  filterByDropdownLabel,
  setSelectedOptionInFilterDropdown,
  createBlipCategoryFilter,
}
